import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { FileType } from '../models/fileType';
import { Invoice } from '../models/invoice';
import { Pagination } from '../models/pagination';
import { FilterInvoicesForm } from '../pages/Invoices/FilterInvoices';

const baseUrl = '/invoice';

const getInvoices = (
  data?: FilterInvoicesForm,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Pagination<Invoice>>> =>
  axios.post<Pagination<Invoice>>(`${baseUrl}/filter`, data, config);

const getTalentInvoices = (
  talentId?: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Pagination<Invoice>>> =>
  axios.get<Pagination<Invoice>>(`${baseUrl}/talent/${talentId}`, config);

const exportInvoices = (
  data?: FilterInvoicesForm
): Promise<AxiosResponse<string>> =>
  axios.post(`${baseUrl}/export`, data, { responseType: 'blob' });

const getInvoiceById = (id: number): Promise<AxiosResponse<Invoice>> =>
  axios.get<Invoice>(`${baseUrl}/${id}`);

const getTalentInvoiceById = (id: number): Promise<AxiosResponse<Invoice>> =>
  axios.get<Invoice>(`${baseUrl}/${id}/talent`);

const approveInvoice = (data: {
  invoiceIds: number[];
  initials: string;
}): Promise<AxiosResponse<void>> => axios.put(`${baseUrl}/approve`, data);

const rejectInvoice = (data: {
  invoiceId: number;
  rejectReason: string;
}): Promise<AxiosResponse<void>> => axios.put(`${baseUrl}/reject`, data);

const createInvoice = ({
  data,
  isDraft
}: {
  data: Invoice;
  isDraft: boolean;
}): Promise<AxiosResponse<Invoice>> =>
  axios.post(`${baseUrl}${isDraft ? '?status=NOT_YET_SUBMITTED' : ''}`, data);

const updateInvoice = ({
  data,
  submit
}: {
  data: Invoice;
  submit: boolean;
}): Promise<AxiosResponse<Invoice>> =>
  axios.put(`${baseUrl}?submit=${submit}`, data);

const saveProjectFiles = (
  invoiceId: number,
  filesData: FormData
): Promise<AxiosResponse<FileType[]>> =>
  axios.post<FileType[]>(`${baseUrl}/files/${invoiceId}`, filesData);

export const invoiceService = {
  getInvoices,
  exportInvoices,
  getInvoiceById,
  approveInvoice,
  rejectInvoice,
  createInvoice,
  saveProjectFiles,
  getTalentInvoiceById,
  getTalentInvoices,
  updateInvoice
};
